module.exports = __webpack_public_path__ + "img/lesson-max.114585bc.png";